export const GIFT_VOUCHER_PARAM = 'is-gift-voucher'
